/* eslint-disable @next/next/no-css-tags */
/* eslint-disable @next/next/no-img-element */

import { sanityClient } from '../../lib/sanity';
import Head from 'next/head';
import Footer from '../../components/footer/Footer';
import Nav from '../../components/navigation/Nav';
import LeadingImagePanelGen from '../../components/LeadingImagePanelGen';
import PinkBar from '../../components/Pinkbar';

import SinglePersonDisplay from '../../components/elements/peeps/SinglePersonDisplay';
import PeopleSliderFlat from '../../components/elements/peeps/PeopleSliderFlat';
import WhiteBlueIllustration from '../../components/elements/WhiteBlueIllustration';

// import NumberedCopyBlock from '../../components/elements/NumberedCopyBlock';
import BreadCrumbs from '../../components/elements/BreadCrumbs';
import CookieConsent from 'react-cookie-consent';

import styles from '../../styles/Home.module.scss';
import Stripe from '../../components/layouts/Stripe';
import GreenQuote from '../../components/GreenQuote';

const singlePersonQuery = `
  {
    "person": *[_type == "people" && slug.current == $slug] | order(_updatedAt desc) {
      _id,
    leadingimage,
    image,
    name,
    slug,
    bio,
    position,
    },
    "allPersonQuery" : *[_type=="people"] | order(_createdAt asc) {
      _id,
      image,
      name,
      slug,
    },

    "companyInfoQuery" : *[_type=="company"]  {
      overlaytitle,
    message,
      title,
      footer,
      sociallinks,
      email,
      numbers
    },
    "currentPageInfoQuery" : *[_id=="b80a9e7f-43b1-49e6-8b33-4b22ec9d7a2d"] {
      title,
      meta,
      introheading,
      pagequote,
      headerimage,
      pinkmessage
    },
  "nurseryQuery" : *[_type=="nurseries"] {
    address,
    linkaddress,
    "manuscriptURL": manuscript.asset->url,
    mapimage
  }
  }
`;

export default function OnePerson({ data }) {
  const slug = data?.person[0]?.slug.current;

  if (!data) return <div>Loading...</div>;
  const { person, allPersonQuery, currentPageInfoQuery, companyInfoQuery, nurseryQuery } = data;

  const PageInfo = currentPageInfoQuery[0];
  const Company = companyInfoQuery;
  const AllPeople = allPersonQuery;
  const Nurseries = nurseryQuery;
  const PageQuote = PageInfo.pagequote;

  const title = `${person[0].name} | ${PageInfo.title} | More2 Nurseries`;

  return (
    <>
      <Head>
        <title>
          {person[0].name} | {title}
        </title>
        <meta name="description" content={person[0].position} />
        {/* <Cononical /> */}
      </Head>
      <Nav CompanyInfo={Company} Nurseries={Nurseries} />

      <LeadingImagePanelGen HeaderImage={PageInfo} headerWidth={1920} headerHeight={600} headerMinHeight={300} hideLink={true} />
      <BreadCrumbs hideLink={true} />

      <div className={styles.mainContent}>
        <div className="container">
          <SinglePersonDisplay person={person[0]} />
        </div>
        <Stripe stripeColor={'#74A2BE'}>
          <PeopleSliderFlat People={AllPeople} numberOfSlidesOnLarge={7} borderColor={'inherit'} headingColor={'#FFF'} />
        </Stripe>
      </div>
      {PageQuote && <GreenQuote quote={PageQuote} />}
      <WhiteBlueIllustration />
      {PageInfo.pinkmessage?.length > 0 && <PinkBar message={PageInfo.pinkmessage} />}
      <Footer CompanyInfo={Company} Nurseries={Nurseries} />
      <CookieConsent
        location="bottom"
        buttonText="I consent"
        cookieName="more2NurseriesConsent"
        style={{ background: '#6FC4C1', textAlign: 'center' }}
        buttonStyle={{ backgroundColor: '#CD8B9B', color: '#FFFF', fontSize: '13px', fontWeight: 'bold', padding: '0.75rem 2rem', borderRadius: '0.51rem' }}
        acceptOnScroll={true}
        acceptOnScrollPercentage={50}
        onAccept={(byScroll) => {
          setConsent(true);
        }}
        expires={150}
      >
        This website uses cookies to enhance the user experience. Do you consent?<span style={{ fontSize: '10px' }}></span>
      </CookieConsent>
    </>
  );
}

export async function getStaticPaths() {
  const paths = await sanityClient.fetch(`*[_type == "people" && defined(slug.current)][].slug.current`);
  return {
    paths: paths.map((slug) => ({ params: { slug } })),
    fallback: false
  };
}

export async function getStaticProps({ params }) {
  const { person, allPersonQuery, currentPageInfoQuery, companyInfoQuery, nurseryQuery } = await sanityClient.fetch(singlePersonQuery, { slug: params.slug });

  return { props: { data: { person, allPersonQuery, currentPageInfoQuery, companyInfoQuery, nurseryQuery } } };
}
